export default __webpack_public_path__ + "static/ProValue_3@1200-ffdc148d8116006c9c23dbcbeb5cd3a8.png";